import { forwardRef } from 'react';
import CloseButton from './close-button';
import NotificationCardInternal from './notification-card-internal';
const NotificationCard = forwardRef(NotificationCardInternal);
const NotificationCardNamespace = Object.assign(NotificationCard, {
    CloseButton,
});
export default NotificationCardNamespace;
